export default "__VITE_ASSET__N1CY3iIE__"